import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressLookupComponent } from './address-lookup.component';
import { MaterialModule } from '@lockton-apps/material';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [AddressLookupComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule],
  exports: [AddressLookupComponent],
})
export class AddressLookupModule {}
